
interface ErrorStateProps {
  error: unknown;
}

export const ErrorState = ({ error }: ErrorStateProps) => {
  const errorMessage = error instanceof Error ? error.message : "Unknown error";
  
  return (
    <div className="p-4 text-red-500 bg-red-50 rounded-md">
      Error loading agents: {errorMessage}
    </div>
  );
};
